import React, { useEffect, useState } from "react";
import Table from "../../../../Components/Tables/Table";
import { getDeskTopBottomSection } from "../Service/InboundServices";
import { RightColumnConfig, RightLineItem, RightSectionProps } from "../Model/Mobile.type";


const RightSection: React.FC<RightSectionProps> = ({desktopRightSection,asnValidateResponse}) => {
  const [data, setData] = useState<RightLineItem[]>();
  const columns = desktopRightSection?.call_back_url_params?.columns?.map(({ title, data }: RightColumnConfig) => {
    if (title === "Item Code" || title === "Item Name") {
      return {
        name: "Items",
        selector: (row: any) => (
          <>
            <div className="fw-bold">{row.name}</div>
            <div>{row.code}</div>
          </>
        ),
      };
    }
    return {
      name: title,
      selector: (row: any) => {
        const cleanData = data.replace('inbound_shipment_line.', '');
        const keys = cleanData.split('.');
        return keys.reduce((acc, key) => (acc ? acc[key] : undefined), row);
      },
    };
  }).filter((col: any, index: number, self: any[]) => 
    index === self.findIndex((c: any) => c.name === col.name)
  ) || [];
  const columns1 = [
    {
      name: "Items",
      selector: (row: RightLineItem) => (
        <>
        <div className="fw-bold">{row.name}</div>
        <div>
          {row.code}
        </div>
        </>
      ),
    },
    {
      name: "UOM",
      selector: (row: RightLineItem) => row.uom_code,
    },
    {
      name: "Expected Qty",
      selector: (row: RightLineItem) => row.qty_expected,
    },
    {
      name: "Received Qty",
      selector: (row: RightLineItem) => row.qty_received,
    },
    
  ];
  useEffect(() => {
    if(desktopRightSection){
      getDeskTopBottomSection(desktopRightSection).then((response)=>{
        setData(response.data.results);
      });
       
  }
}, [desktopRightSection,asnValidateResponse])
    return (data && data?.length >0) ? (
        <div className="mx-3">
          <Table columns={columns} data={data} CheckboxStatus={false} />
        </div>
  ):(<></>);
};

export default RightSection;
